import * as React from 'react';

/*
 * Sparkline — the command-center micro-chart (photos/hr). Line-only in
 * live cards; the area variant backs the big quiet-state card. Scales
 * non-uniformly to its box (preserveAspectRatio="none"), so height is
 * set by the parent via className.
 */

interface SparklineProps {
    series: number[];
    variant?: 'line' | 'area';
    className?: string;
}

export default function Sparkline({
    series,
    variant = 'line',
    className,
}: SparklineProps) {
    const W = 100;
    const H = 30;
    const max = Math.max(...series, 1);
    const points = series.length > 1 ? series : [0, ...series];
    const step = W / (points.length - 1);
    const y = (v: number) => H - 4 - (v / max) * (H - 8);
    const line = points
        .map((v, i) => `${(i * step).toFixed(1)} ${y(v).toFixed(1)}`)
        .join(' L');

    return (
        <svg
            viewBox={`0 0 ${W} ${H}`}
            preserveAspectRatio="none"
            aria-hidden
            className={'block w-full ' + (className ?? '')}
        >
            {variant === 'area' && (
                <path
                    d={`M0 ${H} L${line} L${W} ${H} Z`}
                    fill="hsl(var(--attention))"
                    fillOpacity="0.09"
                />
            )}
            <path
                d={`M${line}`}
                fill="none"
                stroke="hsl(var(--attention))"
                strokeWidth={variant === 'area' ? 1 : 1.4}
                vectorEffect="non-scaling-stroke"
                strokeLinejoin="round"
                strokeLinecap="round"
            />
        </svg>
    );
}
